<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<div class="textbox">
<p class="center"><span class="small01">FOR</span> ELIZABETH OLSEN ALLER<br/><span class="small01">AND</span> FLORENCE BISCEGLIA OLSEN,<br/><span class="small01">TWO OF THE BEST COOKS I KNOW</span>,</p>
<p class="center"><em>and for</em></p>
<p class="center">BEVERLY HEINZLER,<br/>WHO BELIEVES THAT WOMEN CAN</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400187_epub_ded_r1.vue?072d7d7e